<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col cols="12">
        <data-selector
          v-model="reservation.plane_id"
          autofocus
          field-name="plane_id"
          source-type="planes-rentable"
        />
      </v-col>
      <v-col cols="12">
        <data-selector
          v-model="reservation.pilot_id"
          autofocus
          field-name="pilot"
          source-type="pilots"
        />
      </v-col>
      <v-col cols="12">
        <data-selector
          v-model="reservation.instructor_id"
          autofocus
          field-name="instructor"
          source-type="instructors"
          rules=""
        />
      </v-col>
      <v-col cols="12">
        <v-datetime-picker
          v-model="reservation.reservation_start"
          field-name="reservation_start"
          rules="required|datetime"
        />
      </v-col>
      <v-col cols="12">
        <v-datetime-picker
          v-model="reservation.reservation_end"
          field-name="reservation_end"
          rules="required|datetime"
        />
      </v-col>
      <v-col cols="12">
        <validated-text-field
          v-model="reservation.comment"
          field-name="comment"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditReservation',
    props: {
      reservation: Object,
    },
  }
</script>
